"use client";

import { MicrositeListFetchError } from "@/components/shared/MicrositeListFetchError";

interface ClassesPageErrorProps {
  onRetry: () => void;
  isRetrying?: boolean;
}

export const ClassesPageError = ({
  onRetry,
  isRetrying = false,
}: ClassesPageErrorProps) => {
  return (
    <MicrositeListFetchError
      onRetry={onRetry}
      isRetrying={isRetrying}
      testId="classes-page-retry-button"
    />
  );
};
